import { IComponentOptions, IController } from 'angular';
import { IMailsGroupByDate } from '../../shared/mails-by-date.interface';
import './mails-group.component.scss';
import { Mail } from '../../shared/mail';
import { MailboxService } from '../../services';
import { ToastrService } from '../../../../core/services/toastr/toastr.service';

class MailGroupCtrl implements IController {
  static $inject = [
    'MailboxService',
    'ToastrService'
  ];
  onUpdate: () => void;
  checked: boolean;
  group: IMailsGroupByDate;
  onDelete: (obj: any) => void;
  onSelect: (obj: any) => void;
  onCheck: (obj: any) => void;
  onOpen: (obj: any) => void;
  isMobile: boolean;

  constructor( private mailboxService: MailboxService,
               private toastrService: ToastrService ) {

  }

  $onInit() {
  }

  checkGroup(event) {
    this.onCheck({
      $event: {
        check: event.checked,
        selected: event.id
      }
    });
  }

  onImportant( event: Mail ) {
    console.log(event);
    if ( event.important ) {
      return this.mailboxService.deleteFromImportant(event._id)
        .then(() => {
          event.important = false;
        })
        .catch(( err ) => {
          console.log(err);
          this.toastrService.error('Add to important failed', 'Error');
        });
    }
    this.mailboxService.addToImportant(event._id)
      .then(() => {
        event.important = true;
      })
      .catch(( err ) => {
        console.log(err);
        this.toastrService.error('Remove to important failed', 'Error');
      });
  }

  onOpenOne(id) {
    this.onOpen({id: id})
  }

  onDeleteClick( event: Mail ) {
    this.mailboxService.deleteMail(event._id)
      .then(() => {
        this.onUpdate();
      })
      .catch(( err ) => {
        console.log(err);
        this.toastrService.error('Mail delete failed', 'Error');
      });
  }

}

export const MailsGroupComponent: IComponentOptions = {
  controller: MailGroupCtrl,
  template: require('./mails-group.component.html'),
  bindings: {
    group: '<',
    checked: '<',
    onOpen: '&',
    onCheck: '&',
    isOpened: '<',
    onUpdate: '&',
    isMobile: '<'
  }
};



// WEBPACK FOOTER //
// ./app/states/mailbox/components/mails-group/mails-group.component.ts